module.exports = __webpack_public_path__ + "static/media/Venn Diagram.ee738125.svg";